import { ProductCenterRouteMap } from '@/new-router/product-center'

const Home = () => import('@/views/Home/home')

const Material = () => import('@/views/material/material')

/**
 * hidden: true                   是否显示在侧栏上
 * meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
 **/

export default [
  {
    path: '/material',
    name: 'material',
    component: Home,
    meta: {
      title: '素材管理',
      icon: 'icon-configuration',
      showSubiems: false,
      sort: 16,
      modules: 'material',
      permission: 'material:materialManage',
    },
    children: [
      {
        path: 'material-main',
        name: 'material-main',
        title: '素材管理',
        component: Material,
        meta: {
          title: '素材管理',
          active: ['material-main'],
          permission: 'material:materialManage',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.RenderingOfRenderings],
        },
      },
    ],
  },
]
